import { render } from "./Fulfillments.vue?vue&type=template&id=f9e24aac"
import script from "./Fulfillments.vue?vue&type=script&lang=js"
export * from "./Fulfillments.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__